import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { SmartDateFormat } from "../../util/dates"
import { prependAndPlay, playOrPause } from "../../stores/mediaPlayerSlice"
import { compareByKey } from "../../util/utils"
import { useDispatch, useSelector } from "react-redux"
import { usePost } from "../../hooks/usePost"
import { PauseCircle, PlayCircle } from "react-bootstrap-icons"
import { Spinner } from "../../components/shared/Spinner"
import { isMobile } from "react-device-detect"

interface Album {
  id: number
  title: string
  title_cleaned?: string
  post_type_nice?: string
  cover_image_large?: string
  published_at: string
  band_name: string
  nada_path: string
}

interface AlbumSearchResultProps {
  album: Album
}

export const AlbumSearchResult: React.FC<AlbumSearchResultProps> = ({
  album,
}) => {
  const { isLoading, isError, data, error } = usePost(album.id, "songs")
  const [albumName, setAlbumName] = useState("")

  const dispatch = useDispatch()
  const onPlayClick = (e: React.MouseEvent) => {
    if (data?.post?.songs) {
      dispatch(prependAndPlay(sortedSongs()))
    }
  }
  const onPlayOrPauseClick = (e: React.MouseEvent) => {
    dispatch(playOrPause())
  }

  const sortedSongs = () => {
    if (!data?.post?.songs) return []
    return [...data.post.songs]
      .sort((a, b) => compareByKey(a, b, "track_number"))
      .map((song) => ({
        ...song,
        album_name: song.album_name,
        cover_image_small: song.cover_image_small,
      }))
  }

  const currentMediaItem = useSelector(
    // @ts-ignore
    (state: any) => state.mediaPlayer.value.currentMediaItem,
  )
  // @ts-ignore
  const playerState = useSelector((state: any) => state.mediaPlayer.value.playerState)
  const isCurrentlyPlaying =
    playerState === "playing" && currentMediaItem?.albumId === album.id

  useEffect(() => {
    if (data && data.posts && data.posts.length > 0) {
      setAlbumName(data.posts[0].album_name)
    }
  }, [isLoading, data])

  return (
    <li className="col-span-1" style={{ height: "max-content" }}>
      <>
        <div
          style={{
            backgroundColor: "black",
            backgroundImage: album.cover_image_large ? `url(${album.cover_image_large})` : undefined,
            backgroundSize: "cover",
            backgroundPosition: "center",
            aspectRatio: "16/9",
            minHeight: isMobile ? "156px" : "unset",
          }}
          className="w-full overflow-hidden"
        >
          <div
            className="w-full h-full justify-center flex items-center"
            style={{
              background: "rgb(0,0,0,0.3)",
              paddingTop: isMobile ? "36px" : "unset",
              paddingBottom: isMobile ? "36px" : "unset",
            }}
          >
            {isLoading ? (
              <Spinner />
            ) : isError ? (
              <>{error}</>
            ) : data && data.post && data.post.songs.length > 0 ? (
              isCurrentlyPlaying ? (
                <PauseCircle
                  className="text-white cursor-pointer"
                  width="50%"
                  height="50%"
                  onClick={onPlayOrPauseClick}
                />
              ) : (
                <PlayCircle
                  className="text-white cursor-pointer"
                  width="50%"
                  height="50%"
                  onClick={onPlayClick}
                />
              )
            ) : null}
          </div>
        </div>
      </>
      <Link to={album.nada_path}>
        <div className="font-bold leading-tight">{album.title_cleaned || album.title}</div>
        {album.post_type_nice && (
          <div className="font-medium leading-tight text-gray-600 text-xs uppercase">{album.post_type_nice}</div>
        )}
        <div className="text-gray-800 text-sm leading-tight">
          <span className="text-black-800 text-sm">
            {SmartDateFormat({
              dateStr: album.published_at,
              includeTime: false,
            })}
          </span>{" "}
          <span className="text-gray-600 text-sm">by</span>{" "}
          <span className="text-black-800">{album.band_name}</span>
        </div>
      </Link>
    </li>
  )
}

